export default {
    namespaced: true,
    state(){
        return {
            showSidebar: false
        }
    },
    getters: {
        isShowSidebar: state => state.showSidebar
    },
    actions: {
        setShowSidebar({commit}, show) {
            commit('SET_SHOW_SIDEBAR', show)
        }
    },
    mutations: {
        SET_SHOW_SIDEBAR(state, show) {
            state.showSidebar = show
        }
    }
}